module.exports = __webpack_public_path__ + "img/builder-34.f572508e.webp";